import { CertificateV2 } from '@sdir/httpclient/lib/clients/aps/personalcertificate';
import { createContext } from 'react';
import { Loadable } from '../../types';

export const CertificateCodesContext = createContext<Loadable<CertificateV2[]>>({
  loading: false,
  result: null,
  error: null,
});
